import { useCallback } from 'react';
import { Formik } from 'formik';
import PropTypes from 'prop-types';

import FormCard from 'src/components/ui/FormCard';

import DefaultForm from '../DefaultForm';
import { useFormMeeting } from '../hooks/useFormMeeting';

const DefaultFormCMeeting = (props) => {
	const { isPlain, onSubmit, onCancel, serverError, fullHeight, ...rest } = props;

	const handleSubmit = useCallback(
		async (values) => {
			if (onSubmit) {
				await onSubmit(values);
			}
		},
		[onSubmit],
	);

	const { shape, initialValues, validationSchema } = useFormMeeting();

	const form = <DefaultForm {...shape} {...rest} />;

	if (isPlain) return form;

	let result = (
		<Formik
			onSubmit={handleSubmit}
			initialValues={initialValues}
			validationSchema={validationSchema}
			validateOnChange={false}
		>
			{(formikProps) => {
				return (
					<FormCard
						title="Новая встреча"
						fullHeight={fullHeight}
						error={serverError}
						onCancel={onCancel}
						onSubmit={formikProps.handleSubmit}
						onAccept={formikProps.submitForm}
						isLoading={formikProps.isSubmitting}
					>
						{form}
					</FormCard>
				);
			}}
		</Formik>
	);

	return result;
};

DefaultFormCMeeting.propTypes = {
	...DefaultForm.propTypes,
	isPlain: PropTypes.bool,
	onSubmit: PropTypes.func,
	serverError: PropTypes.string,
	fullHeight: PropTypes.bool,
};

export default DefaultFormCMeeting;
